// Русские формы числительного: 1 день, 2 дня, 5 дней, 11 дней, 21 день.
// Единая функция для всего приложения (раньше — копии в lib/akce.ts и
// lib/goals.ts, а на /stats склонения не было вовсе: «Серия 1 дней»).
export function plural(n: number, one: string, few: string, many: string): string {
  const abs = Math.abs(Math.trunc(n))
  const m10 = abs % 10
  const m100 = abs % 100
  if (m10 === 1 && m100 !== 11) return one
  if (m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14)) return few
  return many
}

// Готовые формы для частых слов.
export const DAYS = ['день', 'дня', 'дней'] as const
export const WORDS = ['слово', 'слова', 'слов'] as const
export const LESSONS = ['урок', 'урока', 'уроков'] as const

// «5 дней» — число и форма слова.
export function countLabel(n: number, forms: readonly [string, string, string]): string {
  return `${n} ${plural(n, forms[0], forms[1], forms[2])}`
}
